<template>
  <div class="pageContent mobileRecharge">
    <LoadingModal bgcolor="transparent" />
    <div v-show="!$store.state.pageLoading">
      <Top :title="name" :message="tips" />
      <div class="pageBigRadius pageCarServeShadow phone">
        <div class="pageFlexBetween pageFontWeight phoneType">
          <p>加油广东APP、大家来加油</p>
        </div>
        <div class="phoneNum">
          <van-field
            class="phoneInput"
            v-model="params.account"
            type="number"
            @input="handleInput"
            @blur="blur"
            maxlength="13"
            placeholder="请输入手机号码"
          />
        </div>
      </div>
      <VTitle val="请选择面值" :showLine="false" />
      <TypeList
        :list="selList"
        :activeIndex="selItem"
        @selItem="handleSel"
        :isMember="isMember"
        :canSel="canSel"
        :vip_discount="vip_discount"
      />
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        ref="payway"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="7"
        :params="params"
        :isSend="isSend"
        @onComfirm="handelComfirm"
        :balance="balance"
        :couponsId="couponsId"
        :couponsName="couponsName"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :discount_coupons="discount_coupons"
        :can_use_power="can_use_power"
        :coupon_list="coupon_list"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
      />
      <div id="weapp" style="text-align: center">
        <wx-open-launch-weapp
          id="launch-btn"
          username="gh_85d236dfcbaa"
          path="pages/my-coupon/main.html"
          @launch="handleLaunchFn"
          @error="handleErrorFn"
        >
          <script type="text/wxtag-template">
            <button style="margin-top: 30px;
              text-align: center;
              background:#008915;
              color: rgb(255, 255, 255);
              padding: 10px 15px;
              border-radius: 100px;
              border: 0px;
              width:210px;
              font-size: 14px;color:#fff;">打开"大家来加油"小程序<img  src="http://junfeng.carcq.cn/wxapi/web/images/xcx_ico.png" style="vertical-align: middle;width:16px;height:16px;margin-left:5px;"/></button>
          </script>
        </wx-open-launch-weapp>
      </div>
      <Tips :content="describe" v-if="describe != ''" />
    </div>
  </div>
</template>
<script>
import { submitPayOrder } from "api/submit";
import { getWxApplets } from "api/wechatSDK";
import defaultdata from "server/data/mobileRecharge.json";
import Tips from "server/data/tips.json";
import { getProductList } from "api/onLine";
import Vue from "vue";
export default {
  props: {
    type: String,
    name: String,
    balance: Number,
    couponsId: String,
    couponsName: String,
    couponsDeduct: Number,
    isMember: Boolean,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      appimg: require("assets/sy.png"),
      radio: 1,
      phone: "",
      oldPhone: null,
      area: "",
      // 数据列表
      selList: [],
      selItem: null,
      canSel: false, // 整个列表是否可选
      selListDefaultData: [],
      // 支付数据
      sellData: { sell_price: -1 },
      tips: "电子加油券均设置有效期限，建议按使用量分次充值，另因系统清算，每月末最后一天和次月初第一天暂停使用电子加油券。",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      params: { phone: "" },
      sms: "",
      isSend: false,
      data: {},
      vip_discount: 0,
      discount_coupons: [],
      can_use_power: false,
      coupon_list: [],
      card_id: "",
      chosenCoupon: -1, //优惠券选中索引
      coupons: [], //可用优惠券列表
      disabledCoupons: [], //不可用优惠券列表,
      cid: 0,
      ident: "",
    };
  },
  created() {
    getWxApplets();
    this.$store.commit("setPageLoading", true);
    this.selList = defaultdata.list;
    this.params.account = this.$getItem("userModel").userPhone;
    this.cid = this.$route.query.id;
    this.tips = Tips.tips.oilGD;
    this.ident = this.$route.query.ident;
    this.describe = Tips.describe.oilGD;
  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    screen(val, type) {
      this.$jsonDelete(this.params, "card_id");
      this.chosenCoupon = -1;
      this.coupons = [];
      this.disabledCoupons = [];

      for (let index = 0; index < this.coupon_list.length; index++) {
        const element = this.coupon_list[index];
        let counponinfo = {};
        counponinfo.id = element.card_id;
        counponinfo.name = element.name;
        counponinfo.startAt = Date.parse(element.effect_date) / 1000;
        counponinfo.endAt = Date.parse(element.expire_date) / 1000;
        counponinfo.valueDesc = element.money;
        let des =
          element.describe == ""
            ? "满" + element.full_value + "元可用"
            : element.describe;
        counponinfo.condition = element.full_value == 0 ? "无使用门槛" : des;
        counponinfo.unitDesc = "元";
        if ((val >= element.full_value * 100) & (element.is_can_use == 1)) {
          this.coupons.push(counponinfo);
        } else if (type != 2) {
          this.coupons.push(counponinfo);
        } else {
          this.disabledCoupons.push(counponinfo);
        }
      }
      if ((type == 2) & (this.coupons.length > 0)) {
        this.chosenCoupon = 0;
        this.params.card_id = this.coupons[0].id;
        this.$refs.payway.cname = "抵扣￥" + this.coupons[0].valueDesc;
        this.sellData.sell_price =
          this.selList[this.selItem].sell_price -
          this.coupons[0].valueDesc * 100;
      }
    },
    showCoupons() {
      this.$parent.$parent.parent.$options.parent.showDialogs = true;
    },
    discount_exchange(card_id, is_can_use, money) {
      if (this.selItem < 0) {
        return;
      }
      this.card_id = card_id;
      this.params.card_id = card_id;
      if (is_can_use == 0) {
        this.$error("此卡已被锁定");
        return;
      }
      this.sellData.sell_price =
        this.selList[this.selItem].sell_price - money * 100;
    },
    handleLaunchFn(e) {
      console.log(e);
    },
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    blur() {},
    payOrder(val, data) {
      console.log("加油广东");
      if (val != "") {
        if (this.isSend) {
          this.params.code = val;
        }
        var jsonData = this.$JsonMerge(data, this.params);
        this.$loading("支付中");
        submitPayOrder(jsonData, 7).then((res) => {
          this.$clear();
          if (res.status == 1) {
            this.$successSync("支付成功", () => {
              this.$push({
                path: "/orders?type=-1",
              });
            });
          } else {
            this.$error(res.message);
          }
        });
      }
    },
    handelComfirm(data) {
      this.data = data;
      this.$emit("onComfirm", this.params.phone, this.data);
    },
    resetData() {
      this.selList = this.selListDefaultData.list;
      this.canSel = false;
      this.selItem = null;
      this.sellData = { sell_price: -1 };
    },
    loadData() {
      getProductList(this.ident, this.mouldId).then((res) => {
        this.$clear();
        if (res.status == 200) {
          this.canSel = true;
          this.selList = res.data;
        } else {
          this.resetData();
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
          this.$clear();
        });
      });
    },
    handleInput(val) {
      if (this.params.phone != "") {
        let str = this.params.phone.toString().replace(/ /g, "");
        let len = str.length;
        switch (true) {
          case len > 11:
            str =
              str.substr(0, 3) +
              " " +
              str.substr(3, 4) +
              " " +
              str.substr(7, 4);
            this.params.phone = str;
            break;
          case len > 7:
            str =
              str.substr(0, 3) + " " + str.substr(3, 4) + " " + str.substr(7);
            this.params.phone = str;
            break;
          case len > 3:
            str = str.substr(0, 3) + " " + str.substr(3);
            this.params.phone = str;
            break;
          default:
            this.params.phone = str;
        }
      }
      // 阻止11位后继续触发
      val = val.replace(/\s+/g, "");
      if (val === this.oldPhone) {
        return false;
      }
      this.oldPhone = val;
      if (this.$regPhone(val)) {
        this.canSel = true;
      } else {
        console.log(33333);
        this.canSel = false;
        this.sellData = { sell_price: -1 };
        this.selItem = null;
      }
    },
    handleSel(i, price, originalprice) {
      if (this.selItem == i && price == 0) {
        return;
      }
      this.selItem = i;
      // this.discount = this.selList[i].discount;
      this.sellData = {
        ...this.selList[i],
        sell_price:
          (Number(price) > 0) & (this.selList[i].productIsAnyDeno == "1")
            ? Number(price)
            : Number(this.selList[i].productDenomination),
      };
      this.screen(Number(this.selList[i].productDenomination), 2);
      //任意金额
      console.log(price, this.selList[i].productIsAnyDeno);
      if ((price > 0) & (this.selList[i].productIsAnyDeno == "1")) {
        console.log("进入任意面值");
        this.params.deno = Number(originalprice);
      } else {
        Vue.delete(this.params, "deno");
      }
      if (price == 0 && Number(this.selList[i].productDenomination) == 0) {
        this.sellData.sell_price = -1;
      }
      this.params.productNo = this.selList[i].productNo;
    },
  },
};
</script>

<style scoped lang="less">
.mobileRecharge {
  .launch-weapp {
    width: 100px;
    height: 20px;
  }
  /deep/ .van-coupon-list {
    .van-tabs__wrap {
      padding-top: 0px;
    }
  }
  .discount_coupons {
    background: inherit;
    color: #fff;
    .van-cell {
      padding: inherit;
      align-items: center;
      margin-bottom: 15px;
      box-shadow: #ccc 0 0 5px;
      background: red;
      color: #fff;
      border-radius: 10px;
      .van-cell__title {
        flex: inherit;
        // border-right: 2px solid #cccccc82;
        padding: 10px;
      }
      .van-cell__value {
        // padding: 0px 10px;
        margin: 10px 0px 10px 10px;
        text-align: left;
        color: #fff;
      }
      .van-radio {
        margin-right: 10px;
        color: #fff;
        border-color: #fff;
        border-width: 2px;
      }
      /deep/ .van-icon {
        border: 2px solid #f7f8fa;
      }
      /deep/ .van-radio__icon--checked {
        .van-icon {
          background-color: inherit;
          border-color: inherit;
        }
      }
      .left_money {
        font-size: 26px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 5px;
        padding-right: 15px;
        border-right: 2px solid #cccccc82;
      }
      .left_time {
        background: #fff;
        color: red;
        border-radius: 10px;
        display: flex;
        align-items: center;
        /* justify-content: center; */
        height: 20px;
        font-size: 12px;
        span {
          padding: 0px 5px;
        }
      }
      .right_name {
        font-size: 16px;
        font-weight: bold;
      }
      .right_time {
        font-size: 14px;
      }
    }
  }
  .phone {
    // margin-top: 30px;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    .phoneType {
      font-size: 15px;
      span {
        color: var(--hidColor);
        font-weight: normal;
      }
    }
    .phoneNum,
    .phoneInput {
      font-weight: 900;
      font-size: 30px;
      color: var(--redColor);
    }
    .phoneInput {
      padding: 0;
      /deep/ .van-field__control {
        color: var(--redColor);
      }
    }
  }
}
</style>
